/**
 * Русские тексты для машинных кодов ошибок бэкенда.
 *
 * Бэкенд отдаёт код в поле `error`, и если рядом нет `detail`/`message`, санитайзер
 * показывает пользователю сам код («counterparty_address_invalid_format»). Коды из
 * Core/ErrorCodes.cs, попадающие в интерфейс, обязаны иметь здесь перевод.
 */
const MESSAGES: Record<string, string> = {
    counterparty_address_required:
        'Укажите адрес регистрации — без него ОРД не примет акт для ИП и физлиц',
    counterparty_address_invalid_format:
        'Адрес содержит недопустимые символы. Разрешены русские буквы, цифры, пробел и знаки . , - / ( ) №',
    reporting_window_locked:
        'Правки за этот квартал закрыты — изменения только через обращение в поддержку ЕРИР',
    invoice_type_undeterminable:
        'Не удалось определить тип акта по договору. Проверьте тип договора у контрагента',
    invoice_item_undeterminable:
        'VK ОРД вернул акт без договора или суммы — не удалось добавить обязательную позицию. Откройте акт и проверьте договор и сумму',
    invoice_role_invalid:
        'В акте не указана роль стороны сделки. Проверьте роли заказчика и исполнителя',
    invoice_vat_rate_required:
        'Укажите ставку НДС: «без НДС» и «НДС 0%» — разные значения',
    invoice_comission_incomplete:
        'Для вознаграждения посредника нужны и сумма с НДС, и сумма без НДС',
    ord_provider_unsupported_action:
        'Выбранный ОРД не поддерживает эту операцию',
    ord_user_token_required:
        'Не подключён ключ ОРД. Подключите его в разделе «Настройка»',
}

/** Перевод кода ошибки; undefined — код неизвестен, вызывающий оставляет своё сообщение. */
export function translateErrorCode(code: string): string | undefined {
    return MESSAGES[code.trim()]
}
